import { required, requiredIf } from "vuelidate/lib/validators";
import { DOCUMENT_AVAILABLE_FIELDS } from "@/modules/documents/add-document/document-available-fields.js";

export class DynamicFieldsManager {
  static buildForm(fields = []) {
    const form = {};

    fields.forEach(field => {
      if (field.type === DOCUMENT_AVAILABLE_FIELDS.bool) {
        form[field.name] = undefined;
      } else {
        form[field.name] = null;
      }
    });

    return form;
  }

  static buildFormValidation(fields) {
    return {
      category: { required },
      ...fields.reduce((rules, field) => {
        if (field.required && field.type === DOCUMENT_AVAILABLE_FIELDS.bool) {
          rules[field.name] = {
            required: requiredIf(function(form) {
              return !(field.name in form && [true, false, null, ""].includes(form[field.name]));
            }),
          };
        } else if (field.required) {
          rules[field.name] = { required };
        }

        return rules;
      }, {}),
    };
  }
}
